<section class="planet-grid-panel">
  @if (chartLabel(); as chartName) {
    <div class="chart-label" [style.color]="titleAccentColor()">{{ chartName }}</div>
  }
  <h3 [style.color]="titleAccentColor()">{{ labels().title }}</h3>
  <div class="planet-rows">
    @for (row of rows(); track row.displayConfig.key) {
      <div class="planet-row" [attr.data-planet-key]="row.displayConfig.key">
        <div class="activation-cell design-cell">
          <hd-just-now-planet-activation-cell
            [activation]="row.designActivation"
            kind="design"
            [fixing]="row.designFixing?.baseFixing ?? 'none'"
            [transitFixing]="row.designFixing?.transitFixing ?? 'none'"
            [transitTooltip]="transitTooltip(row.designFixing)"
            [contextMenuEnabled]="contextMenuEnabled()"
            (activationClicked)="planetActivationClicked.emit($event)"
            (contextMenuRequested)="planetBlockContextMenuRequested.emit($event)"
          />
        </div>
        <span class="planet-glyph" [title]="planetName()(row.displayConfig.planetId)">{{ row.displayConfig.astronomiconChar }}</span>
        <div class="activation-cell personality-cell">
          <hd-just-now-planet-activation-cell
            [activation]="row.personalityActivation"
            kind="personality"
            [fixing]="row.personalityFixing?.baseFixing ?? 'none'"
            [transitFixing]="row.personalityFixing?.transitFixing ?? 'none'"
            [transitTooltip]="transitTooltip(row.personalityFixing)"
            [contextMenuEnabled]="contextMenuEnabled()"
            (activationClicked)="planetActivationClicked.emit($event)"
            (contextMenuRequested)="planetBlockContextMenuRequested.emit($event)"
          />
        </div>
      </div>
    }
    @if (designChiron() || personalityChiron()) {
      <div class="planet-row planet-row--chiron" data-planet-key="chiron">
        <div class="activation-cell design-cell">
          @if (designChiron(); as chironVm) {
            <span class="chiron-value" [title]="chironVm.tooltip">{{ chironVm.gate }}.{{ chironVm.line }}</span>
          }
        </div>
        <span class="planet-glyph" [title]="(designChiron() ?? personalityChiron())?.tooltip ?? null">{{ (designChiron() ?? personalityChiron())?.glyph }}</span>
        <div class="activation-cell personality-cell">
          @if (personalityChiron(); as chironVm) {
            <span class="chiron-value" [title]="chironVm.tooltip">{{ chironVm.gate }}.{{ chironVm.line }}</span>
          }
        </div>
      </div>
    }
  </div>
</section>
